import React from "react";

import styles from "./HeroSection.module.scss";

const data = {
  title: "The Ultimate access to Health & Wellness",
  description:
    "You can now buy a single session in the Shyft Pass schedule, and experience the community before you commit to a longer duration!",
};

interface HeroSectionProps {
  h1Tag?: string;
}

const HeroSection: React.FC<HeroSectionProps> = ({ h1Tag }) => (
  <div className={styles.heroSection}>
    {h1Tag ? (
      <h2 className={styles.title}>{data.title}</h2>
    ) : (
      <h1 className={styles.title}>{data.title}</h1>
    )}
    <p className={styles.description}>{data.description}</p>
  </div>
);

export default HeroSection;
